import styles from '../../assets/styles/LandingPage/Header3.module.scss';
import { HashLink as Link } from 'react-router-hash-link';
import { MimaButton } from '../../components';
import { motion, AnimatePresence } from 'framer-motion';
import MimaLogo from '../../assets/img/mima-logo.png';
import { useNavigate } from 'react-router-dom';
import constant from '../../utils/constant';
import { IoMdMenu } from 'react-icons/io';
import { MdCancel } from 'react-icons/md';
import React, { useState } from 'react';

const Header3 = () => {
    const [menu, setMenu] = useState(false);

    const showMenu = () => {
        setMenu(!menu);
    };

    const navigate = useNavigate();
    const switchToSignup = () => {
        navigate(constant.Routes.SignUp);
    };

    const switchToLogin = () => {
        navigate(constant.Routes.Login);
    };

    const switchToLanding = () => {
        navigate(constant.Routes.Home);
    };


    return (
        <header>
            <AnimatePresence>
                {menu && (
                    <motion.div
                        initial={{
                            opacity: 0,
                            y: '-100%',
                        }}
                        animate={{
                            opacity: 1,
                            y: 0,
                            transition: {
                                duration: 0.5,
                            },
                        }}
                        exit={{
                            opacity: 0,

                            y: '-100%',
                            transition: {
                                duration: 0.3,
                            },
                        }}
                        className={styles.menu}>
                        <div className={styles.menu__top}>
                            <img src={MimaLogo} className={styles.menu__logo} alt="Mima Business Logo" onClick={switchToLanding} />
                            <div className={styles.menu__icon} onClick={showMenu}>
                                <MdCancel />
                            </div>
                        </div>

                        <nav>
                            <ul className={styles.menu__nav}>
                                <li className={styles.menu__nav__item} onClick={() => {
                                    navigate(constant.Routes.Home)
                                }}>
                                    <Link
                                        to="#features"
                                        className={styles.menu__nav__link}
                                        onClick={showMenu}>
                                        Products
                                    </Link>
                                </li>
                                <li className={styles.menu__nav__item} onClick={() => {
                                    navigate(constant.Routes.Home)
                                }}>
                                    <Link
                                        to="#testimonial"
                                        className={styles.menu__nav__link}
                                        onClick={showMenu}>
                                        Stories
                                    </Link>
                                </li>
                                <li className={styles.menu__nav__item} onClick={() => {
                                    navigate(constant.Routes.Home)
                                }}>
                                    <Link
                                        to="#subscription"
                                        className={styles.menu__nav__link}
                                        onClick={showMenu}>
                                        Pricing
                                    </Link>
                                </li>
                                {/* <li className={styles.menu__nav__item}>
                                    <Link to={constant.Routes.Article} className={styles.menu__nav__link}>
                                        Articles
                                    </Link>
                                </li> */}
                                <li className={styles.menu__nav__item}>
                                    <Link to={constant.Routes.BlogLanding} className={styles.menu__nav__link}>
                                        Blog
                                    </Link>
                                </li>
                                <li className={styles.menu__nav__item}>
                                    <Link to={constant.Routes.Contact} className={styles.menu__nav__link}>
                                        Contact Us
                                    </Link>
                                </li>
                            </ul>
                        </nav>
                        <div className={styles.menu__nav__btn}>
                            <MimaButton
                                title="Log in"
                                variant="outlined"
                                onClick={switchToLogin}
                                width={38}
                                mb={2}
                            />
                            <MimaButton
                                title="Sign up and get two months free"
                                onClick={switchToSignup}
                            />
                        </div>
                    </motion.div>
                )}
            </AnimatePresence>
            <div className={styles.header}>
                <div className={styles.header__nav}>
                    <img src={MimaLogo} className={styles.logo} alt="Mima Business Logo" onClick={switchToLanding} />
                    <nav>
                        <ul className={styles.nav__item}>
                            <li className={styles.nav__item__list} onClick={() => {
                                navigate(constant.Routes.Home)
                            }}>
                                <Link to="#features" className={styles.menu__nav__link}>
                                    Products
                                </Link>
                            </li>
                            <li className={styles.nav__item__list} onClick={() => {
                                navigate(constant.Routes.Home)
                            }}>
                                <Link to="#testimonial" className={styles.menu__nav__link}>
                                    Stories
                                </Link>
                            </li>
                            <li className={styles.nav__item__list} onClick={() => {
                                navigate(constant.Routes.Home)
                            }}>
                                <Link to="#subscription" className={styles.menu__nav__link}>
                                    Pricing
                                </Link>
                            </li>
                            {/* <li className={styles.nav__item__list} >
                                <Link to={constant.Routes.Article} className={styles.menu__nav__link}>
                                    Articles
                                </Link>
                            </li> */}
                            <li className={styles.nav__item__list} >
                                <Link to={constant.Routes.BlogLanding} className={styles.menu__nav__link}>
                                    Blog
                                </Link>
                            </li>
                            <li className={styles.nav__item__list} >
                                <Link to={constant.Routes.Contact} className={styles.menu__nav__link}>
                                    Contact us
                                </Link>
                            </li>
                        </ul>
                    </nav>
                    <div className={styles.header__nav__btn}>
                        <MimaButton
                            title="Log in"
                            variant="outlined"
                            onClick={switchToLogin}
                        />
                        <MimaButton
                            title="Sign up"
                            onClick={switchToSignup}
                            width={30}
                        />
                    </div>
                    <div className={styles.header__nav_icon} onClick={showMenu}>
                        <IoMdMenu />
                    </div>
                </div>
            </div>
        </header>
    );
};

export default Header3;
